import React from 'react'
import { FiBarChart, FiClipboard } from 'react-icons/fi'
import { ListRequests } from '../requests/ListRequests';
import { NewRequest } from '../requests/NewRequest';
import { EditRequest } from '../requests/EditRequest';
import { useModuleView } from '../../hooks/useModuleView';
import { ReceiveRequests } from '../requests/ReceiveRequests';
import { HistoryRequest } from '../requests/HistoryRequest';

export const Requests = ({ data }) => {

  const viewsMap = {
    list: ListRequests,
    new: NewRequest,
    edit: EditRequest,
    receive: ReceiveRequests,
    history: HistoryRequest,

  };

  const { view, setView, renderView, contextData } = useModuleView('list', viewsMap);

  return (
    <div className="container-fluid">
      {renderView({ parentData: data })}
    </div>
  );
}
